/* Al Ubaid Motors Toyota Yaris Cross MSRP update data. Upload this file to Shopify Assets as aum-toyota-yaris-cross-msrp.js */
(function(){
  const AUM_ROWS = window.AUM_ROWS = window.AUM_ROWS || [];

  function aumSlug(value){
    return String(value || "").toUpperCase().replace(/[^A-Z0-9]+/g,"-").replace(/^-+|-+$/g,"").replace(/-+/g,"-");
  }

  function aumIsToyotaYarisCrossRow(row){
    const text = [
      row && row.make,
      row && row.model,
      row && row.name,
      row && row.variant,
      row && row.variantLabel,
      row && row.method,
      row && row.status,
      row && row.row
    ].join(" ").toUpperCase();
    return text.indexOf("TOYOTA") !== -1 && text.indexOf("YARIS CROSS") !== -1;
  }

  // Replace old/incomplete Toyota Yaris Cross rows with the latest user-provided MSRP rows.
  const keptRows = AUM_ROWS.filter(function(row){ return !aumIsToyotaYarisCrossRow(row); });
  AUM_ROWS.length = 0;
  keptRows.forEach(function(row){ AUM_ROWS.push(row); });

  const AUM_TOYOTA_YARIS_CROSS_PACKED = `03/2026|X|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2026|2126300|1110|4180mm × 1765mm × 1590mm
03/2026|G|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2026|2341900|1120|4180mm × 1765mm × 1590mm
03/2026|X|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2026|2373800|1200|4180mm × 1765mm × 1590mm
03/2026|HYBRID X|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2026|2510200|1160|4180mm × 1765mm × 1590mm
03/2026|HYBRID U|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2026|2549800|1160|4180mm × 1765mm × 1590mm
03/2026|G|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2026|2589400|1210|4180mm × 1765mm × 1590mm
03/2026|Z|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2026|2621300|1150|4180mm × 1765mm × 1590mm
03/2026|HYBRID G|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2026|2712600|1170|4180mm × 1765mm × 1590mm
03/2026|Z URBANO|1|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2026|2731300|1150|4180mm × 1765mm × 1590mm
03/2026|Z ADVENTURE|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2026|2736800|1150|4200mm × 1765mm × 1590mm
03/2026|HYBRID X|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2026|2757700|1250|4180mm × 1765mm × 1590mm
03/2026|HYBRID U|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2026|2797300|1250|4180mm × 1765mm × 1590mm
03/2026|Z|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2026|2868800|1240|4180mm × 1765mm × 1590mm
03/2026|HYBRID G|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2026|2960100|1250|4180mm × 1765mm × 1590mm
03/2026|Z URBANO|1|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2026|2978800|1240|4180mm × 1765mm × 1590mm
03/2026|Z ADVENTURE|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2026|2984300|1240|4200mm × 1765mm × 1590mm
03/2026|HYBRID Z|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2026|2992000|1200|4180mm × 1765mm × 1590mm
03/2026|HYBRID Z URBANO|1|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2026|3102000|1200|4180mm × 1765mm × 1590mm
03/2026|HYBRID Z ADVENTURE|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2026|3107500|1200|4200mm × 1765mm × 1590mm
03/2026|HYBRID Z|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2026|3239500|1280|4180mm × 1765mm × 1590mm
03/2026|HYBRID Z URBANO|1|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2026|3349500|1280|4180mm × 1765mm × 1590mm
03/2026|HYBRID Z ADVENTURE|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2026|3355000|1280|4200mm × 1765mm × 1590mm
02/2025|X|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2025|2046000|1110|4180mm × 1765mm × 1590mm
02/2025|G|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2025|2172500|1120|4180mm × 1765mm × 1590mm
02/2025|X|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2025|2277000|1200|4180mm × 1765mm × 1590mm
02/2025|G|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2025|2403500|1210|4180mm × 1765mm × 1590mm
02/2025|HYBRID X|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2025|2433200|1160|4180mm × 1765mm × 1590mm
02/2025|HYBRID U|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2025|2472800|1160|4180mm × 1765mm × 1590mm
02/2025|Z|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2025|2513500|1140|4180mm × 1765mm × 1590mm
02/2025|HYBRID G|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2025|2546500|1170|4180mm × 1765mm × 1590mm
02/2025|Z URBANO|1|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2025|2623500|1140|4180mm × 1765mm × 1590mm
02/2025|Z ADVENTURE|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2025|2629000|1140|4200mm × 1765mm × 1590mm
02/2025|GR SPORT|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2025|2648800|1130|4185mm × 1765mm × 1580mm
02/2025|HYBRID X|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2025|2664200|1250|4180mm × 1765mm × 1590mm
02/2025|HYBRID U|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2025|2703800|1250|4180mm × 1765mm × 1590mm
02/2025|Z|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2025|2744500|1230|4180mm × 1765mm × 1590mm
02/2025|HYBRID G|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2025|2777500|1250|4180mm × 1765mm × 1590mm
02/2025|Z URBANO|1|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2025|2854500|1230|4180mm × 1765mm × 1590mm
02/2025|Z ADVENTURE|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2025|2860000|1230|4200mm × 1765mm × 1590mm
02/2025|HYBRID Z|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2025|2887500|1190|4180mm × 1765mm × 1590mm
02/2025|HYBRID Z URBANO|1|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2025|2997500|1190|4180mm × 1765mm × 1590mm
02/2025|HYBRID Z ADVENTURE|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2025|3003000|1190|4200mm × 1765mm × 1590mm
02/2025|HYBRID GR SPORT|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2025|3031600|1180|4185mm × 1765mm × 1580mm
02/2025|HYBRID Z|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2025|3118500|1270|4180mm × 1765mm × 1590mm
02/2025|HYBRID Z URBANO|1|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2025|3228500|1270|4180mm × 1765mm × 1590mm
02/2025|HYBRID Z ADVENTURE|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2025|3234000|1270|4200mm × 1765mm × 1590mm
01/2024|X|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2024|1907000|1110|4180mm × 1765mm × 1590mm
01/2024|X|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2024|2138000|1200|4180mm × 1765mm × 1590mm
01/2024|G|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2024|2150000|1120|4180mm × 1765mm × 1590mm
01/2024|HYBRID X|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2024|2295000|1160|4180mm × 1765mm × 1590mm
01/2024|G|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2024|2381000|1210|4180mm × 1765mm × 1590mm
01/2024|Z|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2024|2435000|1140|4180mm × 1765mm × 1590mm
01/2024|HYBRID U|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2024|2451000|1160|4180mm × 1765mm × 1590mm
01/2024|HYBRID G|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2024|2524000|1170|4180mm × 1765mm × 1590mm
01/2024|HYBRID X|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2024|2526000|1250|4180mm × 1765mm × 1590mm
01/2024|Z ADVENTURE|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2024|2551000|1140|4200mm × 1765mm × 1590mm
01/2024|GR SPORT|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2024|2571000|1130|4185mm × 1765mm × 1580mm
01/2024|Z|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2024|2666000|1230|4180mm × 1765mm × 1590mm
01/2024|HYBRID U|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2024|2682000|1250|4180mm × 1765mm × 1590mm
01/2024|HYBRID G|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2024|2755000|1250|4180mm × 1765mm × 1590mm
01/2024|Z ADVENTURE|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2024|2782000|1230|4200mm × 1765mm × 1590mm
01/2024|HYBRID Z|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2024|2809000|1190|4180mm × 1765mm × 1590mm
01/2024|HYBRID Z ADVENTURE|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2024|2925000|1190|4200mm × 1765mm × 1590mm
01/2024|HYBRID GR SPORT|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2024|2954000|1180|4185mm × 1765mm × 1580mm
01/2024|HYBRID Z|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2024|3040000|1270|4180mm × 1765mm × 1590mm
01/2024|HYBRID Z ADVENTURE|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2024|3156000|1270|4200mm × 1765mm × 1590mm
08/2022|X|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2022|1896000|1110|4180mm × 1765mm × 1590mm
08/2022|G|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2022|2020000|1120|4180mm × 1765mm × 1590mm
08/2022|X|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2022|2127000|1200|4180mm × 1765mm × 1590mm
08/2022|Z|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2022|2232000|1140|4180mm × 1765mm × 1590mm
08/2022|G|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2022|2251000|1210|4180mm × 1765mm × 1590mm
08/2022|HYBRID X|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2022|2284000|1160|4180mm × 1765mm × 1590mm
08/2022|Z ADVENTURE|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2022|2331000|1140|4200mm × 1765mm × 1590mm
08/2022|GR SPORT|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2022|2367000|1130|4185mm × 1765mm × 1580mm
08/2022|HYBRID G|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2022|2394000|1170|4180mm × 1765mm × 1590mm
08/2022|Z|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2022|2463000|1230|4180mm × 1765mm × 1590mm
08/2022|HYBRID X|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2022|2515000|1250|4180mm × 1765mm × 1590mm
08/2022|Z ADVENTURE|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2022|2562000|1230|4200mm × 1765mm × 1590mm
08/2022|HYBRID Z|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2022|2606000|1190|4180mm × 1765mm × 1590mm
08/2022|HYBRID G|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2022|2625000|1250|4180mm × 1765mm × 1590mm
08/2022|HYBRID Z ADVENTURE|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2022|2705000|1190|4200mm × 1765mm × 1590mm
08/2022|HYBRID GR SPORT|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2022|2750000|1180|4185mm × 1765mm × 1580mm
08/2022|HYBRID Z|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2022|2837000|1270|4180mm × 1765mm × 1590mm
08/2022|HYBRID Z ADVENTURE|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2022|2936000|1270|4200mm × 1765mm × 1590mm
08/2020|X B PACKAGE|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2020|1798000|1110|4180mm × 1765mm × 1590mm
08/2020|X|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2020|1896000|1110|4180mm × 1765mm × 1590mm
08/2020|G|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2020|2020000|1120|4180mm × 1765mm × 1590mm
08/2020|X B PACKAGE|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2020|2029000|1200|4180mm × 1765mm × 1590mm
08/2020|X|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2020|2127000|1200|4180mm × 1765mm × 1590mm
08/2020|Z|0|5BA-MXPB10|MXPB10|1490|5|5|SUV|PETROL|FF|2020|2210000|1140|4180mm × 1765mm × 1590mm
08/2020|G|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2020|2251000|1210|4180mm × 1765mm × 1590mm
08/2020|HYBRID X|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2020|2284000|1160|4180mm × 1765mm × 1590mm
08/2020|HYBRID G|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2020|2394000|1170|4180mm × 1765mm × 1590mm
08/2020|Z|0|5BA-MXPB15|MXPB15|1490|5|5|SUV|PETROL|4WD|2020|2441000|1230|4180mm × 1765mm × 1590mm
08/2020|HYBRID X|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2020|2515000|1250|4180mm × 1765mm × 1590mm
08/2020|HYBRID Z|0|6AA-MXPJ10|MXPJ10|1490|5|5|SUV|HYBRID|FF|2020|2584000|1190|4180mm × 1765mm × 1590mm
08/2020|HYBRID G|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2020|2625000|1250|4180mm × 1765mm × 1590mm
08/2020|HYBRID Z|0|6AA-MXPJ15|MXPJ15|1490|5|5|SUV|HYBRID|4WD|2020|2815000|1270|4180mm × 1765mm × 1590mm`;

  AUM_TOYOTA_YARIS_CROSS_PACKED.trim().split(/\n+/).forEach(function(line){
    const p = line.split("|");
    const sale = p[0] || "";
    const variantRaw = p[1] || "";
    const limited = p[2] === "1";
    const fullCode = p[3] || "";
    const chassis = p[4] || fullCode;
    const cc = Number(p[5] || 0);
    const doors = Number(p[6] || 0);
    const seats = Number(p[7] || 0);
    const type = p[8] || "SUV";
    const fuel = p[9] || "PETROL";
    const drive = p[10] || "";
    const year = Number(p[11] || 0);
    const msrp = Number(p[12] || 0);
    const weightKg = Number(p[13] || 0);
    const dimensions = p[14] || "";
    const rowId = "TOYOTA-YARIS-CROSS-" + aumSlug(chassis) + "-" + aumSlug(variantRaw) + "-" + aumSlug(sale) + "-" + msrp;
    const variantLabel = variantRaw + (limited ? " · Limited Model" : "") + (seats ? " · " + seats + " Seats" : "") + " · " + fullCode + " · Sale " + sale;

    const row = {
      row: rowId,
      chassis: chassis,
      make: "TOYOTA",
      model: "YARIS CROSS",
      name: "TOYOTA YARIS CROSS",
      variant: variantRaw,
      variantLabel: variantLabel,
      type: type,
      fuel: fuel,
      year: year,
      cc: cc,
      doors: doors,
      seats: seats,
      drive: drive,
      cur: "JPY",
      msrp: msrp,
      method: "TOYOTA YARIS CROSS MSRP",
      sourceUrl: "https://www.goo-net-exchange.com/catalog/TOYOTA__YARIS_CROSS/",
      status: "Manual MSRP · TOYOTA YARIS CROSS · " + fullCode + " · Sale " + sale + " · User provided"
    };
    if(weightKg) row.weightKg = weightKg;
    if(dimensions) row.dimensions = dimensions;
    AUM_ROWS.push(row);
  });
})();
